import React, { FC } from 'react';
import { Button, Theme, styled, useTheme } from '@material-ui/core';
import { ProfilePicture } from '../../../shared/components';
import { useUser } from '../../../shared';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { UserRole } from 'src/config/api/models/User';

type Props = {
  open: boolean;
  onClick: () => void;
};

const StyledUserMenuButton = styled(Button)<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  padding: theme.spacing(0, 2),
  cursor: 'pointer',
  textAlign: 'left',
  textTransform: 'none',
  borderRadius: 0,
  transition: theme.config.defaultTransition,
}));

const StyledUserInfo = styled('div')<Theme>(({ theme }) => ({
  marginLeft: theme.spacing(2),
  gap: theme.spacing(4),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const StyledUserName = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.h5.fontSize,
  fontWeight: 700,
  lineHeight: theme.typography.body2.lineHeight,
  color: theme.palette.offblack,
}));

const StyledUserRoleInfo = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.bodyLg.fontSize,
  fontWeight: 400,
  lineHeight: theme.typography.body2.lineHeight,
  color: theme.palette.grey['A100'],
}));

const UserMenuButton: FC<Props> = ({ open, onClick }) => {
  const theme = useTheme();
  const { user } = useUser();

  /* TODO - NEEDS TRANSLATION*/
  const userRoleMenuLabel: Record<UserRole, string> = {
    admin: 'Admin Lernova',
    'super-admin': 'Super-admin Lernova',
    author: 'Auteur Lernova',
    teacher: 'Leerkracht',
    student: 'Student',
  };

  const firstUserRole = user.roles[0];

  return (
    <StyledUserMenuButton
      // Do not remove this id - It serves the trajectory subheader layout
      id="user-menu-button"
      onClick={onClick}
      aria-describedby="menu-list-grow"
      aria-controls="menu-list-grow"
      aria-haspopup="true"
    >
      <ProfilePicture user={user} size="medium" />
      <StyledUserInfo>
        <span>
          <StyledUserName>
            {user.firstName} {user.name}
          </StyledUserName>
          {/* TODO - NEEDS TRANSLATION*/}
          <StyledUserRoleInfo>{`${userRoleMenuLabel[firstUserRole]}`}</StyledUserRoleInfo>
        </span>
        <FontAwesomeSpriteIcon
          iconSize="xs"
          color={theme.palette.common.black}
          icon={open ? SpriteIconsLight.ANGLE_UP : SpriteIconsLight.ANGLE_DOWN}
        />
      </StyledUserInfo>
    </StyledUserMenuButton>
  );
};

export default UserMenuButton;
